import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

interface DetailsPaneStylesProps {
  canEdit: boolean
  disabled: boolean
  smallMedia: boolean
}

const useStyles = makeStyles<Theme, DetailsPaneStylesProps>(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    flex: ({ smallMedia }) => (smallMedia ? '0' : '1'),
    borderRight: '1px solid rgba(230, 234, 236, 0.9)',
    boxSizing: 'border-box',
    maxWidth: ({ smallMedia }) => (smallMedia ? '100%' : '24rem'),
    backgroundColor: 'white',
    borderRadius: '10px 0 0 10px',
    padding: '1.5rem 0'
  },

  title: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '1.5rem 0',
    minWidth: '250px',
    position: 'relative'
  },

  avatar: {
    width: '6.75rem',
    height: '6.75rem',
    fontSize: theme.size.xxxl,
    cursor: ({ canEdit }) => (canEdit ? 'pointer' : 'default')
  },

  avatarImg: {
    borderRadius: '100%',
    position: 'absolute',
    height: '100%',
    width: '100%',
    objectFit: 'cover',
    objectPosition: 'top center'
  },

  name: {
    fontSize: theme.size.xl,
    textAlign: 'center',
    color: '#323436',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    '& > div': {
      opacity: '0.35',
      cursor: 'default'
    }
  },

  nameInput: {
    border: 'none',
    outline: 'none',
    padding: 0,
    background: 'transparent',
    fontSize: theme.size.xl,
    textAlign: 'center',
    color: '#323436',
    width: 'calc(100% - 2rem)',
    textOverflow: 'ellipsis'
  },

  time: {
    fontSize: theme.size.sm
  },

  pointer: {
    cursor: 'pointer'
  },

  fields: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    paddingTop: '40px',

    [theme.breakpoints.down('md')]: {
      paddingLeft: '0'
    }
  },

  fieldsContainer: {
    display: 'flex',
    flexDirection: 'column'
  },

  field: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    marginTop: '1rem'
  },

  fieldName: {
    marginBottom: '3px',
    fontSize: theme.size.xs,
    color: '#7F8487'
  },

  fieldValue: {
    color: '#323436'
  },

  status: {
    justifyContent: 'unset',
    cursor: ({ canEdit }) => (canEdit ? 'pointer' : 'default'),
    fontSize: theme.size.xs
  },

  type: {
    justifyContent: 'unset',
    cursor: ({ disabled }) => (disabled ? 'default' : 'pointer'),
    fontSize: theme.size.xs
  },

  timezone: {
    fontSize: theme.size.xs
  },

  created: {
    opacity: '0.7',
    fontSize: theme.size.xs
  },

  goto: {
    bottom: '9px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: '1.5rem',
    marginTop: 'auto',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: 225
  },

  gotoBtn: {
    width: 'auto',
    fontSize: theme.size.sm
  },

  uploadIcon: {
    padding: '0.25rem',
    fontSize: theme.size.lg,
    borderRadius: '100%',
    backgroundColor: 'white',
    border: '1px solid rgba(230, 234, 236, 0.9)',
    position: 'absolute',
    bottom: '0',
    right: '4rem',
    cursor: ({ canEdit }) => (canEdit ? 'pointer' : 'default'),
    transition: 'background-color 250ms',

    '&:hover': {
      backgroundColor: '#d3d3d37f'
    }
  },

  clearIcon: {
    padding: '0.25rem',
    fontSize: theme.size.lg,
    borderRadius: '100%',
    backgroundColor: 'white',
    border: '1px solid rgba(230, 234, 236, 0.9)',
    position: 'absolute',
    top: '0',
    right: '4rem',
    cursor: ({ canEdit }) => (canEdit ? 'pointer' : 'default'),
    transition: 'background-color 250ms',

    '&:hover': {
      backgroundColor: '#d3d3d37f'
    }
  },

  arrow: {
    display: 'flex',
    justifyContent: 'flex-end'
  },

  communicationsRoot: {
    marginRight: '0 !important',
    overflow: 'auto !important',
    flex: 1
  },

  inputClass: {
    display: 'grid !important',
    gridTemplateColumns: '1fr',
    marginTop: '1rem',
    gridGap: 4,

    '&:first-child': {
      marginTop: '0'
    }
  }
}))

export default useStyles
